export const ACTION_TYPES_BY_PLATFORM = {
    pluglead: [
        { value: 'webhook_call', label: 'Chamada de Webhook para PlugLead' },
    ],
    webhook: [
        { value: 'webhook_call', label: 'Chamada de Webhook' },
    ],
    activecampaign: [
        { value: 'tag_add', label: 'Adicionar tag ao contato' },
        { value: 'list_add', label: 'Adicionar contato à lista' },
    ],
};

// Shared action_config contract with the backend generic webhook adapter
// (core-platform Modules/Integration — HasWebhookActionRules).
export const DEFAULT_WEBHOOK_CONFIG = {
    url: '',
    method: 'POST',
    content_type: 'application/json',
    auth: { type: 'none' },
    headers: [],
    field_mappings: [],
    static_fields: {},
    body_template: null,
};

export const WEBHOOK_METHODS = ['GET', 'POST', 'PUT', 'PATCH', 'DELETE'];

export const WEBHOOK_AUTH_TYPES = [
    { value: 'none', label: 'Nenhuma' },
    { value: 'bearer', label: 'Bearer token' },
    { value: 'basic', label: 'Basic (usuário e senha)' },
    { value: 'api_key', label: 'API Key (cabeçalho)' },
];

export const WEBHOOK_CONTENT_TYPES = [
    { value: 'application/json', label: 'JSON (application/json)' },
    { value: 'application/x-www-form-urlencoded', label: 'Formulário (x-www-form-urlencoded)' },
];

// Variables available in field mappings / body_template. The payment.* group
// resolves on payment events (payments.*) — the dispatch attaches the charge
// context; test fires substitute a sample payment object.
export const WEBHOOK_FIELD_SOURCES = [
    { value: 'email', label: 'E-mail' },
    { value: 'name', label: 'Nome completo' },
    { value: 'contactFirstName', label: 'Primeiro nome' },
    { value: 'phone', label: 'Telefone' },
    { value: 'payment', label: 'Pagamento (objeto completo)' },
    { value: 'payment.id', label: 'Pagamento — ID da cobrança' },
    { value: 'payment.plan_id', label: 'Pagamento — ID do plano' },
    { value: 'payment.subscription_id', label: 'Pagamento — ID da assinatura' },
    { value: 'payment.amount', label: 'Pagamento — Valor (centavos)' },
    { value: 'payment.net_amount', label: 'Pagamento — Valor líquido (centavos)' },
    { value: 'payment.currency', label: 'Pagamento — Moeda' },
    { value: 'payment.method', label: 'Pagamento — Método' },
    { value: 'payment.confirmed_at', label: 'Pagamento — Confirmado em' },
    { value: 'payment.split', label: 'Pagamento — Divisão (lista)' },
];

export const DEFAULT_ACTIONS_BY_PLATFORM = {
    pluglead: [{ type: 'webhook_call', config: { webhook_url: '' } }],
    webhook: [{ type: 'webhook_call', config: { ...DEFAULT_WEBHOOK_CONFIG } }],
    activecampaign: [],
};

export function getDefaultConfigForType(type, platform) {
    switch (type) {
        case 'tag_add': return { tag_id: '', tag_name: '' };
        case 'list_add': return { list_id: '' };
        default:
            // Same webhook_call type, two shapes: PlugLead keeps the legacy
            // single-URL config; the generic webhook uses the full contract.
            return platform === 'webhook'
                ? { ...DEFAULT_WEBHOOK_CONFIG }
                : { webhook_url: '' };
    }
}

export function generateDescription(event, planId, platform, community) {
    const triggers = {
        'payments.confirmed': 'um pagamento for confirmado',
        'payments.pix_generated': 'um Pix for gerado',
        'payments.checkout_dropped': 'um checkout for abandonado',
    };
    const destinations = {
        pluglead: 'PlugLead',
        webhook: 'um endpoint externo via webhook',
        activecampaign: 'ActiveCampaign',
    };

    if (!event || !platform) return null;

    const plan = community?.plans?.find(p => String(p.id) === String(planId));
    const planLabel = plan ? `no plano "${plan.label}"` : 'em qualquer plano';
    const trigger = triggers[event] || event;
    const dest = destinations[platform] || platform;

    return `Quando ${trigger} ${planLabel}, o Ginastee irá enviar os dados do comprador para ${dest}.`;
}

let _keyCounter = 0;
export function newActionKey() {
    return `ak_${++_keyCounter}_${Date.now()}`;
}
